<template lang="html">

  <section class="informes pad-sec">
    <div class="container">

      <div class="col-50">
        <h2 class="title title-36">{{$t('area_tecnica.tips.titulo')}}</h2>
        <p>{{$t('area_tecnica.tips.texto_1')}}</p>
        <p>{{$t('area_tecnica.tips.texto_2')}}</p>
      </div>

      <section class="search search-informe">

        <div class="flex wrap row-start" v-if="tips.length > 0">

          <input type="text" class="input-text search-keyword" :placeholder="$t('area_tecnica.tips.por_keyword')" v-model="search.keyword"/>

          <div class="select-style">
            <select v-model="search.categoria">
              <option value="">{{$t('area_tecnica.tips.filtrar')}}</option>
              <option :key="key" v-for="(categorie, key) in getCategories" :value="categorie" >{{categorie}}</option>
            </select>
          </div>

        </div>

        <div class="keywords-list">
          <keyword v-for="(keyword, key) in search.keyword_list" :data="keyword" @erase="eraseKeyword(keyword)" :key="key">{{keyword}}</keyword>
        </div>

        <div class="row-start desplegable--predictivo" v-if="filteredKeywords.length > 0" >
          <ul class="filtro-despl flex row wrap">
            <keyword-to-select v-for="(keyword, key) in filteredKeywords" :key="key" :data="keyword" @click="addToFilter(keyword)"></keyword-to-select>
          </ul>
        </div>


      </section>

      <div class="results" v-if="!!tips">
        <p v-if="tips.length != filteredTips.length">{{$t('area_tecnica.tips.resultado')}}</p>
        <p v-if="tips.length != filteredTips.length">{{$t('area_tecnica.tips.mostrando')}} {{filteredTips.length}} {{resultados_string}}</p>

        <div class="mask-pagination" v-if="filteredTips.length > 0">
          <div class="flex row">
            <ul class="download-informe page">
              <tip v-for="(tip, key) in sliceTips" :key="key" :data="tip"></tip>
            </ul>
          </div>
        </div>

        <paginador v-on:change="changePage" :numPost="filteredTips.length"></paginador>
        
      </div>
      <div class="block-layout">
        <h3 class="title title-26">{{$t('area_tecnica.tips.novedades')}}</h3>
        <ul class="download-informe flex row wrap align-stretch">
          <tip-novedad v-for="(tip, key) in filteredTips.slice(0,3)" :key="key" :data="tip"></tip-novedad>
        </ul>
      </div>
    </div>
  </section>

</template>

<script lang="js">  


  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'

  Vue.use(VueAxios, axios);

  import {mapGetters, mapActions } from 'vuex'

  import KeywordToSelect from '@/components/parts/keyword-to-select';
  import Keyword from '@/components/parts/keyword';
  import Tip from '@/components/view-parts/area-tecnica/tip';
  import TipNovedad from '@/components/view-parts/area-tecnica/tip-novedad';
  import paginador from '@/components/parts/paginador'

  export default  {
    name: 'informes-tecnicos',
    props: [],
    created() {
    if (this.getTips.length === 0) {
      this.fetchTips(this.getLanguage);
    } else {
      this.tips = this.getTips;
      }
    },
    data() {
      return {
        search : {
          keyword : '',
          categoria : '',
          keyword_list : [],
        },
        page : 1,
        tips : ''
      }
    },
  methods: {
      ...mapActions({
        fetchTips: 'fetchTips'
      }),
      changePage : function(value){
        this.page = value;
      },
      addToFilter : function(value){
        this.search.keyword_list.push(value);
        this.search.keyword = '';
      },
      eraseKeyword : function(value){
        let temporal = this.search.keyword_list.filter(e => e != value);
        this.search.keyword_list = temporal;
      },
   },
   computed: {
    ...mapGetters(['getLanguage', 'getTips', 'getLanguage']),
    getKeyWords : function (){
      let keywords = new Array();

      if(this.tips.length > 0){

        this.tips.forEach( function(element, index) {
          element.keywords.forEach(e => {
            if(!keywords.some(k => k == e)){
              keywords.push(e);
            }
          });
        });

      }

      return keywords;
    },
    filteredKeywords : function() {
      let keywords = '';

      if(!!this.tips){

        if(this.search.keyword.length >= 3){ 
          keywords = this.getKeyWords.filter(e => e.toLowerCase().includes(this.search.keyword.toLowerCase()));
        }
      }
      return keywords;
    },
    getCategories : function() {
      let categories = new Array();
      if(!!this.tips){
        this.tips.forEach(function (element, index) {
          element.categories.forEach((categorie) => {
            if (!categories.some(k => k == categorie)) {
              categories.push(categorie);
            }
          })
        });
      }
      return categories.sort();
    },
    filteredByCategorie : function (){

      let tips;

      let cleanTips = new Array();

      if(!!this.search.categoria){
        tips = this.tips.filter(e => e.categories.find((category => category) === this.search.categoria));
      }else{
        tips = this.tips.slice();
      }

      if(tips != undefined && tips.length > 0) {
        tips.forEach(t => {
          if(!cleanTips.some(ct => ct.id == t.id)){
            cleanTips.push(t);
          }
        });
      }

      return cleanTips;

    },
    filteredTips : function(){


      let tips = new Array();

      if(this.search.keyword_list.length > 0){

        this.filteredByCategorie.forEach(tip => {

          let flag = true;

          this.search.keyword_list.forEach( function(keyword, index) {
            if(flag){
              flag = tip.keywords.some(t => t == keyword);                
            }
          });

          if(flag){
            tips.push(tip);
          }
        });

      }else{
        tips = this.filteredByCategorie.slice();
      }

      return tips;

    },
    sliceTips : function (){

      let from = (this.page-1) * 10;
      let to = this.page * 10;

      let tips;

      if(this.filteredTips.length > 0){
        tips= this.filteredTips.slice(from, to);
      }

      return tips;
    },

    resultados_string : function(){
      let string;
      if(this.getLanguage == "es"){
        string = (this.filteredTips.length == 1) ? 'resultado' : 'resultados';
      }else{
        string = (this.filteredTips.length == 1) ? 'result' : 'results';
      }
      return string;
    }
  },
  components : {
    'keyword-to-select' : KeywordToSelect,
    'keyword' : Keyword,
    'tip' : Tip,
    'tip-novedad' : TipNovedad,
    'paginador' : paginador
  },
  watch: {
      getTips(newValue) {
        this.tips = newValue; // Asigna los datos cuando cambian
    }
  },
}
</script>

<style scoped>

.search-informe{
  position: relative;
  margin-bottom: 50px;
}

.filtro-despl{
  margin-left: 0;
  max-width: 100%;
}

.filtro-despl li{
  width: 25%;
}

.search-keyword{
  margin-right: 20px;
}

.desplegable--predictivo{
  position: absolute;
  left: 0;
  top: 70px;
  width: 100%;
  display: inline-block;
  z-index: 5;
}

.download-informe{
  width: 100%;
}

.filtro-despl .contenedor-check input:checked + label::before{
  content: '';
}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/area-tecnica/informes-tecnicos.vue